<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark>
        <v-btn icon dark @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>템플릿</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-tabs v-model="activeTab" background-color="grey lighten-4" color="primary" show-arrows>
        <v-tab href="#game">
          <v-icon left small>mdi-file-document-edit-outline</v-icon>게임 템플릿
        </v-tab>
        <v-tab href="#choice">
          <v-icon left small>mdi-format-list-checks</v-icon>선택지 그룹
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="activeTab">
        <!-- 탭1: 게임 템플릿 — 개발자 전용 (등록/수정은 권한 가드) -->
        <v-tab-item value="game">
          <v-card-text class="pa-0">
            <v-alert v-if="!devMode" dense text type="info" class="ma-3 body-2">
              게임 템플릿은 <b>개발자만 등록/수정</b> 가능합니다. (현재 read-only)
            </v-alert>
            <div style="overflow-x: auto;">
            <v-data-table
              :headers="headers"
              :items="templateList"
              :items-per-page="20"
              :footer-props="{'items-per-page-options':[20, 50, -1]}"
              class="elevation-0"
            >
              <template v-slot:item.is_active="{ item }">
                <v-chip small :color="item.is_active ? 'green' : 'grey'" dark>{{ item.is_active ? '활성' : '비활성' }}</v-chip>
              </template>
              <template v-slot:item.game_mode="{ item }">
                <v-chip small outlined>{{ gameModeLabel(item.game_mode) }}</v-chip>
              </template>
              <template v-slot:item.schedule_type="{ item }">
                <span class="text-caption">{{ scheduleLabel(item) }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn v-if="devMode" icon small @click="openEditDialog(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                <span v-else class="caption grey--text">read-only</span>
              </template>
            </v-data-table>
            </div>
            <v-container v-if="templateList.length === 0" class="text-center py-8">
              <v-icon size="64" color="grey lighten-1">mdi-file-document-edit-outline</v-icon>
              <p class="text-body-1 grey--text mt-3">등록된 게임 템플릿이 없습니다.</p>
            </v-container>
          </v-card-text>
        </v-tab-item>

        <!-- 탭2: 선택지 그룹 — 운영자가 그때그때 등록/수정 -->
        <v-tab-item value="choice">
          <Danta_ChoiceGroupManage />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- 등록/수정 다이얼로그 -->
    <v-dialog v-model="dialog" max-width="780" scrollable>
      <v-card>
        <v-card-title class="pb-0">
          <v-icon left color="primary">mdi-file-document-edit-outline</v-icon>
          {{ isEdit ? form.template_name || '템플릿 수정' : '템플릿 등록' }}
          <v-spacer></v-spacer>
          <v-chip v-if="form.template_code" small outlined class="ml-2">{{ form.template_code }}</v-chip>
        </v-card-title>
        <v-tabs v-model="editTab" color="primary" class="mt-1">
          <v-tab><v-icon left small>mdi-information-outline</v-icon>기본정보</v-tab>
          <v-tab><v-icon left small>mdi-clock-outline</v-icon>운영 시간</v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-card-text class="pa-5" style="min-height: 380px;">
          <v-tabs-items v-model="editTab">
            <v-tab-item>
              <v-row dense class="mt-2">
                <v-col cols="12" sm="6">
                  <v-text-field v-model="form.template_code" label="템플릿 코드 *" outlined dense class="mb-3" :disabled="isEdit" placeholder="CRYPTO_BTC, STOCK_SAMSUNG" hint="종목별 고유 코드. 중복 불가, 등록 후 변경 불가" persistent-hint></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="form.template_name" label="템플릿 명칭 *" outlined dense hide-details class="mb-3" placeholder="비트코인, 삼성전자"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-select v-model="form.game_mode" :items="gameModeOptions" label="게임 모드 *" outlined dense hide-details class="mb-3" @change="onGameModeChange"></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select v-model="form.result_type" :items="resultTypeOptions" label="판정 방식" outlined dense hide-details class="mb-3" :disabled="form.game_mode === 'price'"></v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="form.data_source" label="데이터 소스 *" outlined dense hide-details class="mb-3" placeholder="upbit, kis_ko, kis_us, kis_rest, manual"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="form.ws_url" label="WebSocket URL" outlined dense hide-details class="mb-3" placeholder="wss://..."></v-text-field>
                </v-col>
              </v-row>
              <v-textarea v-model="form.description" label="설명" outlined dense hide-details class="mb-3" rows="2"></v-textarea>
              <v-switch v-model="form.is_active" label="활성 상태" hide-details></v-switch>
            </v-tab-item>
            <v-tab-item>
              <div class="text-subtitle-2 font-weight-bold mb-3 mt-2">
                <v-icon small left>mdi-clock-outline</v-icon>운영 시간
              </div>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-select v-model="form.schedule_type" :items="scheduleTypeOptions" label="운영 타입 *" outlined dense hide-details class="mb-3"></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="form.snapshot_interval" label="가격 수집 간격 (초)" outlined dense hide-details class="mb-3" type="number"
                    persistent-hint hint="watcher 의 가격 snapshot 주기. 기본 5초."></v-text-field>
                </v-col>
              </v-row>
              <v-row dense v-if="form.schedule_type === 'market_hours'">
                <v-col cols="6">
                  <v-text-field v-model="form.market_open" label="장 시작" outlined dense hide-details class="mb-3" placeholder="09:00"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.market_close" label="장 종료" outlined dense hide-details class="mb-3" placeholder="15:30"></v-text-field>
                </v-col>
              </v-row>
              <v-alert dense text type="info" class="body-2 mt-2">
                <b>라운드 주기 / 입찰 마감 / 선택지</b> 는 게임 단(games / 선택지 그룹) 에서 관리합니다.
              </v-alert>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">취소</v-btn>
          <v-btn color="primary" depressed @click="save">
            <v-icon left small>mdi-check</v-icon>{{ isEdit ? '수정' : '등록' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="py-12"></div>
    <div class="py-12"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Danta_ChoiceGroupManage from './Choice_Group_Manage.vue';
export default {
  name: 'Danta_GameTemplateManage',
  components: { Danta_ChoiceGroupManage },
  data: () => ({
    activeTab: 'game',
    // 게임 템플릿 등록/수정은 개발자 전용. live 빌드면 read-only.
    devMode: process.env.NODE_ENV !== 'production',
    dialog: false,
    isEdit: false,
    editTab: 0,
    templateList: [],
    headers: [
      { text: 'ID', value: 'template_id', width: '50px' },
      { text: '코드', value: 'template_code', width: '130px' },
      { text: '명칭', value: 'template_name', width: '120px' },
      { text: '모드', value: 'game_mode', width: '90px' },
      { text: '소스', value: 'data_source', width: '80px' },
      { text: '운영', value: 'schedule_type', width: '120px' },
      { text: '상태', value: 'is_active', width: '70px' },
      { text: '', value: 'actions', width: '50px', sortable: false },
    ],
    scheduleTypeOptions: [
      { text: '24시간 운영', value: '24h' },
      { text: '장시간 운영 (시작~종료)', value: 'market_hours' },
      { text: '종가 기준 (1일 1회)', value: 'close' },
    ],
    gameModeOptions: [
      { text: '가격 예측 (상승/하락)', value: 'price' },
      { text: '스포츠 결과', value: 'sports' },
      { text: '퀴즈 N지선다', value: 'quiz' },
      { text: '커스텀', value: 'custom' },
    ],
    resultTypeOptions: [
      { text: '자동 판정', value: 'auto' },
      { text: '수동 판정', value: 'manual' },
    ],
    form: {},
  }),
  created() {
    this.resetForm();
    this.loadTemplateList();
  },
  methods: {
    ...mapActions(['DANTA_GET_GAME_TEMPLATE_LIST', 'DANTA_CREATE_GAME_TEMPLATE', 'DANTA_UPDATE_GAME_TEMPLATE']),
    async loadTemplateList() {
      try {
        const data = await this.DANTA_GET_GAME_TEMPLATE_LIST();
        this.templateList = data.template_list || [];
      } catch (err) { console.error('템플릿 로드 실패:', err); }
    },
    resetForm() {
      this.form = {
        template_code: '', template_name: '', description: '',
        data_source: '', ws_url: '',
        game_mode: 'price', result_type: 'auto',
        snapshot_interval: 5,
        market_open: '', market_close: '',
        is_active: true,
      };
    },
    openRegistDialog() {
      this.isEdit = false;
      this.resetForm();
      this.editTab = 0;
      this.dialog = true;
    },
    openEditDialog(item) {
      this.isEdit = true;
      this.form = JSON.parse(JSON.stringify(item));
      this.editTab = 0;
      this.dialog = true;
    },
    onGameModeChange() {
      // game_mode 변경 시 result_type 자동 셋. 선택지는 별도 그룹으로 관리.
      const presets = {
        price:  { result_type: 'auto' },
        sports: { result_type: 'manual' },
        quiz:   { result_type: 'manual' },
        custom: { result_type: 'manual' },
      };
      const p = presets[this.form.game_mode] || presets.custom;
      this.form.result_type = p.result_type;
    },
    gameModeLabel(mode) {
      const map = { price: '가격예측', sports: '스포츠', quiz: '퀴즈', custom: '커스텀' };
      return map[mode] || mode || '-';
    },
    scheduleLabel(item) {
      if (item.schedule_type === '24h') return '24시간';
      if (item.schedule_type === 'market_hours') return (item.market_open || '?') + ' ~ ' + (item.market_close || '?');
      if (item.schedule_type === 'close') return '종가 기준';
      return '-';
    },
    async save() {
      if (!this.form.template_code || !this.form.template_name || !this.form.data_source) {
        alert('템플릿 코드, 명칭, 데이터소스는 필수입니다.');
        return;
      }
      try {
        const data = JSON.parse(JSON.stringify(this.form));
        if (this.isEdit) {
          await this.DANTA_UPDATE_GAME_TEMPLATE(data);
        } else {
          await this.DANTA_CREATE_GAME_TEMPLATE(data);
        }
        this.dialog = false;
        await this.loadTemplateList();
      } catch (err) {
        console.error(err);
        alert(this.isEdit ? '템플릿 수정에 실패했습니다.' : '템플릿 등록에 실패했습니다.');
      }
    },
  },
};
</script>
